export const THEME_PROPERTIES = {
    THEME_NAME: "theme",
    LOADER: "loader", //IMAGE URL LOADER
    BACKGROUND: "background",
    IS_DEFAULT: "isDefault",
    NEED_TITLE_HOME: "needTitleHome",
    COLOR: "color",
    LOADER_TYPE: "loaderType",
    CURRENCY: "currency",
    DETAIL_IMAGE: "detail_image",
    DESCRIPTION_HOME: "description_home",
};

export const AVAILABLE_THEMES = {
    jetbarra: {
        theme: "JET",
        loaderType: "CUSTOM",
        loader: require("./JET/assets/new-loader-jet.webp"),
        background: require("./JET/assets/new-background-jet.jpg"),
        isDefault: false,
        needTitleHome: true,
        currency: "$",
        detail_image: true,
        description_home: true,
    },
    jetterraza: {
        theme: "JET",
        loaderType: "CUSTOM",
        loader: require("./JET/assets/new-loader-jet.webp"),
        background: require("./JET/assets/new-background-jet.jpg"),
        isDefault: false,
        needTitleHome: true,
        currency: "$",
        detail_image: true,
        description_home: true,
    },
    jetmesas: {
        theme: "JET",
        loaderType: "CUSTOM",
        loader: require("./JET/assets/new-loader-jet.webp"),
        background: require("./JET/assets/new-background-jet.jpg"),
        isDefault: false,
        needTitleHome: true,
        currency: "$",
        detail_image: true,
        description_home: true,
    },
    mowi: {
        theme: "MOWI",
        loaderType: "LOGO",
        loader: require("./MOWI/assets/loader.webp"),
        color: "#49007D",
        background: "",
        isDefault: true,
        needTitleHome: false,
        currency: "$USD",
        detail_image: true,
        description_home: false,
    },
    default: {
        theme: "DEFAULT",
        loaderType: "DEFAULT",
        loader: "",
        background: "",
        isDefault: true,
        needTitleHome: false,
        currency: "$",
        detail_image: true,
        description_home: false,
    },
};

export const THEME_STYLES = {
    jetbarra: "JET",
    jetmesas: "JET",
    jetbarravip: "JET",
    default: "DEFAULT",
};
